import React, { useState, useEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import {
  Row, Col, Typography, Card, Form, Button, message,
  Input,
} from 'antd';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { getUserMail, getUserType } from '../../../../../../utils/users';
import SelectedLands from '../../../../serviceComponents/selectedLands/SelectedLands';
import GeoMapSummary from '../../../../serviceComponents/geoMapSummary/GeoMapSummary';
import AreaTalhao from '../../../../../sharedComponents/talhao/AreaTalhao';
import UploadFiles from '../../../../serviceComponents/uploadFiles/UploadFiles';
import { isItEstimateOrService } from '../../../../../../utils/service';
import { SessionExpiredException } from '../../../../../../utils/errors';
import {
  post, get, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../../../../../dataSource/requests';
import './Summary.scss';

const Summary = (props) => {
  const [formInstance] = Form.useForm();
  const navigate = useNavigate();
  const userType = getUserType();

  const uploadFilesReference = useRef(null);
  const [valueAttachmentSizeCooperated, setValueAttachmentSizeCooperated] = useState(null);

  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState(null);

  const titleOrcamento = useRef(false);

  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const {
    removeSelectedField, serviceRequestParameters, nextPage, previousPage,
  } = props;

  const getLabel = (idCode, value) => {
    switch (idCode) {
      case 'GEOFERT-ZONA_MANEJO-SATELITE-V_DESEJADO':
        return 'V% desejado';
      case 'GEOFERT-ZONA_MANEJO-SATELITE-PRNT_CALCARIO':
        return 'PRNT do Calcário';
      case 'GEOFERT-ZONA_MANEJO-SATELITE-PRNT_OXIDO':
        return 'PRNT do Óxido';
      case 'GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR':
        return 'Houve aplicação de maturador?';
      case 'GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR':
        return 'Data da aplicação de maturador';
      case 'GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR':
        return 'Nome do produto utilizado';
      case 'GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO':
        return 'Houve tombamento?';
      case 'GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO':
        return 'Data de tombamento';
      case 'GEOFERT-ZONA_MANEJO-DATA_PLANTIO':
        return 'Data de plantio';
      case 'GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE':
        return 'Estágio de corte';
      case 'GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE':
        return 'Data do último corte';
      case 'GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE':
        return 'Data do penúltimo corte';
      case 'GEOFERT-ZONA_MANEJO-VARIEDADE':
        return 'Variedade';

      case 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO':
        if (value === '') return '';
        return 'Valor unitário';
      case 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL':
        if (value === '') return '';
        return 'Valor total';
      case 'GEOFERT-ZONA-MANEJO-SATELITE-CONDICAO_PAGAMENTO':
        if (value === '') return '';
        return 'Condição de pagamento';
      case 'GEOFERT-ZONA-MANEJO-SATELITE-FORMA_PAGAMENTO':
        if (value === '') return '';
        return 'Forma de pagamento';
      case 'GEOFERT-ZONA-MANEJO-SATELITE-OBSERVACOES':
        if (value === '') return '';
        return 'Observações do orçamento';
      default:
        return `${idCode}`;
    }
  };

  const getField = (idCodeParameter) => {
    return serviceRequestParameters
      .serviceRequestFieldInputList
      .find(
        (field) => {
          return field.idCode === idCodeParameter;
        },
      );
  };

  const printValue = (idCode, value) => {
    switch (true) {
      case (value === true):
      case (value === 'true'):
        return 'Sim';

      case (value === false):
      case (value === 'false'):
        return 'Não';

      case (value?._isAMomentObject):
        return value.format('DD/MM/YYYY');

      case (/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z/.test(value)):
        return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').format('DD/MM/YYYY');

      case (idCode === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO' && value !== ''):
        return currencyFormatter.format(value);

      case (idCode === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL' && value !== ''):
        return currencyFormatter.format(value);

      default:
        return value;
    }
  };

  const renderField = (idCodeParameter) => {
    const field = getField(idCodeParameter);

    if (field !== undefined) {
      if (idCodeParameter === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO' && field.value !== '') {
        titleOrcamento.current = true;
      }

      return (
        <Row className="ZonaManejoSummary__DetailRow">
          <Col className="ZonaManejoSummary__DetailParentColumn" span={24}>

            {
              idCodeParameter === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO' && field.value !== ''
              && (
                <>
                  <hr />
                  <p className="ZonaManejoSummary__SessionTitle">Orçamento</p>
                </>
              )
            }

            {
              titleOrcamento.current === false
              && idCodeParameter === 'GEOFERT-ZONA-MANEJO-SATELITE-OBSERVACOES'
              && field.value !== ''
              && (
                <>
                  <hr />
                  <p className="ZonaManejoSummary__SessionTitle">Orçamento</p>
                </>
              )
            }

            <Row className="ZonaManejoSummary__DetailChildRow" justify="space-between">
              <Col className="ZonaManejoSummary__DetailColumn">{getLabel(idCodeParameter, field.value)}</Col>
              <Col className="ZonaManejoSummary__DetailSpecificColumn"><b>{printValue(idCodeParameter, field.value)}</b></Col>
            </Row>
          </Col>
        </Row>
      );
    }

    return null;
  };

  const mask = (rawValue) => {
    if (rawValue.length > 14) {
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  };

  const getAttachmentParamenters = async () => {
    try {
      const requestRef: RequestWrapper = get({
        url: '/system/getAttachmentParamenters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const response = await requestRef;

      setValueAttachmentSizeCooperated(
        response?.body.getAttachmentParamentersOutput.attachmentSizeCooperated,
      );
    } catch (error) {
      message.error('Ocorreu um erro ao buscar informações, tente novamente');
    }
  };

  useEffect(() => {
    getAttachmentParamenters();
    return () => {
      setLoading(false);
    };
  }, []);

  const userMailCooperative = () => {
    const targetMail = getUserMail() ? getUserMail().replaceAll('"', '') : '-';

    return (
      <div>
        <div>
          <span>{`Email: ${userType === 'COOPERATIVE' ? targetMail : '-'}`}</span>
        </div>
        <div>
          <span style={{ fontSize: '.7rem' }}>(caso esteja incorreto, informar e-mail válido no campo observação)</span>
        </div>
      </div>
    );
  };

  const onFormFinish = async (values) => {
    setLoading(true);
    let response;

    let telValue = values.TelInput;
    telValue = !telValue ? '' : telValue.replace(/\D/g, '');

    const data = {
      landFieldsIds: serviceRequestParameters.talhoesSelecionados.map((v) => v.id),
      landId: serviceRequestParameters.selectedProperty.id,
      landOwnerId: serviceRequestParameters.selectedOwner.id,
      serviceId: serviceRequestParameters.selectedService.id,
      cooperativeNotes: values.observacao,
      telephone: telValue,
      serviceTypeId: serviceRequestParameters.selectedType.id,
      serviceSubtypeId: serviceRequestParameters.selectedSubType.id,
      haveCtc: serviceRequestParameters.haveCtc,
      ctc: serviceRequestParameters.ctc,
      branchCoopercitrusId: serviceRequestParameters.branchCoopercitrusId,
    };

    if (userType === 'COOPERATIVE') {
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-ZONA-MANEJO-SATELITE-CONDICAO_PAGAMENTO',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-ZONA-MANEJO-SATELITE-FORMA_PAGAMENTO',
        value: '',
      });
      serviceRequestParameters.serviceRequestFieldInputList.push({
        idCode: 'GEOFERT-ZONA-MANEJO-SATELITE-OBSERVACOES',
        value: '',
      });
    }

    let targetUrl = '';
    if (serviceRequestParameters.choiceServiceType === 1) {
      targetUrl = '/budget/requestBudgetService';
      data.budgetRequestFieldInputs = serviceRequestParameters.serviceRequestFieldInputList;
    } else {
      targetUrl = '/service/requestService';
      data.serviceRequestFieldInputList = serviceRequestParameters.serviceRequestFieldInputList;
    }

    try {
      const requestRef: RequestWrapper = post({
        url: targetUrl,
        params: data,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
      }
      setLoading(false);
      return;
    }

    if (!response?.body.error) {
      if (response?.body.code === 5002) {
        flushSync(() => {
          setRequestId(response?.body.createServiceRequestOutput.serviceRequestId);
        });
      } else {
        flushSync(() => {
          setRequestId(response?.body.createBudgetOutput.budgetId);
        });
      }

      const uploadError = !uploadFilesReference.current.validateFiles();
      if (!uploadError) {
        try {
          await uploadFilesReference.current.handleSubmitFiles();
        } catch (error) {
          setLoading(false);
          return;
        }

        nextPage({});
      }
    } else if (response?.body.code === -6006) {
      message.error('Esta cultura não é válida para este serviço');
    } else {
      message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
    }

    setLoading(false);
  };

  return (
    <div className="ZonaManejoSummary">
      <Row
        justify="space-between"
        className="ZonaManejoSummary__TitleRow"
      >
        <Col
          className="ZonaManejoSummary__TitleCol"
        >
          <Typography.Title
            level={1}
            className="ZonaManejoSummary__Title"
          >
            Resumo da Solicitação
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="ZonaManejoSummary__ContentRow"
      >
        <Col
          span={24}
          className="ZonaManejoSummary__ContentColumn"
        >
          <Card
            className="ZonaManejoSummary__ContentCard"
          >
            <Form
              scrollToFirstError
              className="ZonaManejoSummary__Form"
              form={formInstance}
              onFinish={onFormFinish}
              layout="vertical"
              onFinishFailed={
                (errorInfo) => {
                  console.log('grid summary form finish failed:', errorInfo);
                }
              }
            >
              <Row
                gutter={[24, 24]}
                className="ZonaManejoSummary__DetailsRow"
              >
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="ZonaManejoSummary__DetailsColumn"
                >
                  <Row
                    gutter={[24, 24]}
                    className="ZonaManejoSummary__ServiceTitleRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__ServiceTitleCol"
                    >
                      <Typography.Title
                        level={1}
                        className="ZonaManejoSummary__ServiceFullTitle"
                      >
                        <span className="ZonaManejoSummary__ServiceTitle">{'Geofert: '}</span>
                        <span className="ZonaManejoSummary__ServicesTypeTitle">Zona de Manejo</span>
                      </Typography.Title>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__SubtypeRow"
                  >
                    <Col
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__SubtypeColumn"
                      xs={{ span: 24 }}
                    >
                      Tipo de Zona de Manejo: Satélite
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__MatriculaRow"
                  >
                    <Col
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__MatriculaColumn"
                      xs={{ span: 24 }}
                    >
                      {`Matrícula: ${serviceRequestParameters.selectedProperty.matriculation}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__CooperadoRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__CooperadoColumn"
                    >
                      {`Cooperado: ${serviceRequestParameters.selectedOwner.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__PropriedadeColumn"
                    >
                      {`Propriedade: ${serviceRequestParameters.selectedProperty.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__PropriedadeColumn"
                    >
                      {
                        userMailCooperative()
                      }
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__PropriedadeColumn"
                    >
                      <span>{`Possui CTC: ${serviceRequestParameters.haveCtc ? 'Sim' : 'Não'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__PropriedadeColumn"
                    >
                      <span>{`CTC: ${serviceRequestParameters.ctc ? serviceRequestParameters.ctc : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__PropriedadeColumn"
                    >
                      <span>{`Filial: ${serviceRequestParameters.branchName ? serviceRequestParameters.branchName : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__DetailRow ZonaManejoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__DetailColumn ZonaManejoSummary__PropriedadeColumn"
                    >
                      {renderField('GEOFERT-ZONA_MANEJO-SATELITE-V_DESEJADO')}
                      {renderField('GEOFERT-ZONA_MANEJO-SATELITE-PRNT_CALCARIO')}
                      {renderField('GEOFERT-ZONA_MANEJO-SATELITE-PRNT_OXIDO')}
                      {renderField('GEOFERT-ZONA_MANEJO-VARIEDADE')}
                      {renderField('GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE')}
                      {renderField('GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE')}
                      {renderField('GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE')}
                      {renderField('GEOFERT-ZONA_MANEJO-DATA_PLANTIO')}
                      {renderField('GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO')}
                      {renderField('GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO')}
                      {renderField('GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR')}
                      {renderField('GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR')}
                      {renderField('GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR')}

                      {renderField('GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO')}
                      {renderField('GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL')}
                      {renderField('GEOFERT-ZONA-MANEJO-SATELITE-CONDICAO_PAGAMENTO')}
                      {renderField('GEOFERT-ZONA-MANEJO-SATELITE-FORMA_PAGAMENTO')}
                      {renderField('GEOFERT-ZONA-MANEJO-SATELITE-OBSERVACOES')}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__PhoneRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__PhoneColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="ZonaManejoSummary__PhoneTitle"
                      >
                        Telefone para contato
                      </Typography.Title>
                      <Form.Item
                        name="TelInput"
                        className="ZonaManejoSummary__PhoneFormItem"
                        validateTrigger={['onBlur']}
                        rules={[
                          {
                            required: true,
                            message: 'Por favor, insira um telefone.',
                          },
                          {
                            min: 14,
                            message: 'Telefone inválido',
                          },
                        ]}
                      >
                        <MaskedInput
                          guide={false}
                          mask={mask}
                          placeholder="Telefone"
                          className="ant-input ZonaManejoSummary__PhoneMaskedInput"
                          maxLength={15}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__CommentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__CommentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="ZonaManejoSummary__CommentsTitle"
                      >
                        Observação
                      </Typography.Title>
                      <Form.Item
                        className="ZonaManejoSummary__CommentsFormItem"
                        name="observacao"
                        rules={[
                          {
                            max: 1000,
                            message: 'A observação deve ter no máximo 1000 caractéres',
                          },
                        ]}
                      >
                        <Input.TextArea
                          className="obsArea ZonaManejoSummary__CommentsInput"
                          xs={{ span: 24 }}
                          lg={{ span: 10 }}
                          rows={4}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="ZonaManejoSummary__AttachmentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ZonaManejoSummary__AttachmentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="ZonaManejoSummary__AttachmentsTitle"
                      >
                        Anexos do cooperado
                      </Typography.Title>
                      <Form.Item
                        name="anexo"
                        className="ZonaManejoSummary__AttachmentsFormItem"
                      >
                        <div className="attachments-items-container">
                          <UploadFiles
                            ref={uploadFilesReference}
                            origin="summary"
                            requestType={
                              isItEstimateOrService(
                                serviceRequestParameters.choiceServiceType === 1 ? 'ORCAMENTO' : 'SERVICO',
                                userType,
                              )
                            }
                            typeUser="SERVICE_REQUEST_CUSTOMER_FILE"
                            action="edit"
                            id={requestId}
                            fileSize={valueAttachmentSizeCooperated}
                            initialFiles={
                              [].map((item) => ({ ...item, uid: item.id, status: 'done' }))
                            }
                          />
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="ZonaManejoSummary__GeomapColumn"
                >
                  <SelectedLands
                    talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                    removeSelectedField={removeSelectedField}
                  />

                  <div
                    className="ZonaManejoSummary__AreaTalhaoSpacing"
                  >
                  </div>

                  <AreaTalhao
                    talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                  />

                  <GeoMapSummary
                    params={serviceRequestParameters}
                  />
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                justify="end"
                className="ZonaManejoSummary__ButtonRow"
              >
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="ZonaManejoSummary__ButtonFirstColumn"
                >
                  <Button
                    block
                    className="ZonaManejoSummary__BackButton"
                    onClick={() => previousPage()}
                    loading={loading}
                  >
                    <ArrowLeftIcon className="ZonaManejoSummary__ArrowLeftIcon" />
                    Voltar
                  </Button>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="ZonaManejoSummary__ButtonSecondColumn"
                >
                  <Form.Item
                    className="ZonaManejoSummary__ContinueButtonFormItem"
                  >
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="ZonaManejoSummary__ContinueButton"
                      loading={loading}
                    >
                      Confirmar Solicitação
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row >
    </div >
  );
};

Summary.propTypes = {
  removeSelectedField: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    haveCtc: PropTypes.bool,
    ctc: PropTypes.string,
    branchCoopercitrusId: PropTypes.number,
    choiceServiceType: PropTypes.number,
    branchName: PropTypes.string,
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.any).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.any),
    service: PropTypes.string,

    serviceRequestFieldInputList: PropTypes.arrayOf(
      PropTypes.shape({
        idCode: PropTypes.string.isRequired,
        value: PropTypes.any,
      }),
    ),

    selectedProperty: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      registeredOn: PropTypes.instanceOf(moment),
      matriculation: PropTypes.string,

      location: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),
    }),

    selectedType: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),

    selectedSubType: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),

    selectedService: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),

    selectedOwner: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    }),

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Summary.defaultProps = {};

export default Summary;
